
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bulletin-neige",
      function () {
        return require("private-next-pages/bulletin-neige.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bulletin-neige"])
      });
    }
  